import "./infinite-scroll.css";
import { InfiniteScroll } from './infinite-scroll';
export default InfiniteScroll;